import React from 'react';

import { useIntl } from 'react-intl';
import { padStartTwoDigits as pad } from 'utils/utils.string';
import { DateFormat, extractDate, dateLabel } from 'utils/utils.date';

export interface JRCDateProps {
    date?: string;
    dateSeparator?: '/' | '-' | ' ';
    timeSeparator?: ':' | ' ';
    useHumanDisplay?: boolean;
    format?: DateFormat;
    smartDate?: boolean;
}

const DATETIME_SEPARATPOR = ' ';

export const JRCDate = (props: JRCDateProps) => {
    const intl = useIntl();
    if (!props.date) return <></>;

    const { date: d, month: mn, year, hours: h, minutes: m, seconds: s } = extractDate(props.date);

    let list: Array<string | number> = [];

    const label = props.smartDate && dateLabel(props.date);
    const DATE_SEPERATOR = props.dateSeparator ?? '/';
    const TIME_SEPERATOR = props.timeSeparator ?? ':';
    const minutes = pad(m);
    const seconds = pad(s);
    const hours = pad(h);
    const date = pad(d);
    const month = pad(mn);

    if (props.format === 'date' || !props.format) {
        list = [date, DATE_SEPERATOR, month, DATE_SEPERATOR, year];
        if (label) {
            list = [intl.formatMessage({ id: label })];
        }
    }
    if (props.format === 'date-time') {
        list = [date, DATE_SEPERATOR, month, DATE_SEPERATOR, year, DATETIME_SEPARATPOR, hours, TIME_SEPERATOR, minutes];
        if (label) {
            list = [intl.formatMessage({ id: label }), DATETIME_SEPARATPOR, hours, TIME_SEPERATOR, minutes];
        }
    }
    if (props.format === 'date-time-sec') {
        list = [
            date,
            DATE_SEPERATOR,
            month,
            DATE_SEPERATOR,
            year,
            DATETIME_SEPARATPOR,
            hours,
            TIME_SEPERATOR,
            minutes,
            TIME_SEPERATOR,
            seconds,
        ];
        if (label) {
            list = [
                intl.formatMessage({ id: label }),
                DATETIME_SEPARATPOR,
                hours,
                TIME_SEPERATOR,
                minutes,
                TIME_SEPERATOR,
                seconds,
            ];
        }
    }
    if (props.format === 'time') {
        list = [hours, TIME_SEPERATOR, minutes];
    }
    if (props.format === 'time-sec') {
        list = [hours, TIME_SEPERATOR, minutes, TIME_SEPERATOR, seconds];
    }

    return <>{list.join('')}</>;
};
